import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.to-fixed.js";
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-16bf93fa"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "campaigns-card d-flex fl-s-b"
};
var _hoisted_2 = {
  class: "d-flex"
};
var _hoisted_3 = {
  class: "d-flex fl-j-c fl-a-c picture-container"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  key: 1,
  class: "f-bold picture-placeholder"
};
var _hoisted_6 = {
  class: "d-flex flex-column fl-s-b details-container"
};
var _hoisted_7 = {
  class: "f-bold"
};
var _hoisted_8 = {
  class: "code"
};
var _hoisted_9 = {
  class: "f-bold value"
};
var _hoisted_10 = {
  class: "apply-button-container d-flex fl-j-c fl-a-c"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_SvgIcon = _resolveComponent("SvgIcon");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_ctx.data.picture ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: _ctx.data.picture
  }, null, 8, _hoisted_4)) : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.data.name.charAt(0)), 1))]), _createElementVNode("div", _hoisted_6, [_createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.data.name), 1), _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.data.code), 1), _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.data.flatValue ? (_ctx.data.flatValue / 100).toFixed(2) : "".concat(_ctx.data.percentageValue, "%")), 1)])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("button", {
    class: _normalizeClass(["apply-button d-flex fl-j-c fl-a-c", {
      active: _ctx.data.isApplied
    }]),
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    function () {
      return _ctx.onToggleApplyPromocode && _ctx.onToggleApplyPromocode.apply(_ctx, arguments);
    })
  }, [_createTextVNode(_toDisplayString(_ctx.data.isApplied ? _ctx.$t("button.applied") : _ctx.$t("promocode.apply")) + " ", 1), _ctx.data.isApplied ? (_openBlock(), _createBlock(_component_SvgIcon, {
    key: 0,
    iconContent: _ctx.RoundCheckIcon,
    iconAlt: "",
    iconStyle: "width: 18px;\n        height: 18px; margin-left: 6px;"
  }, null, 8, ["iconContent"])) : _createCommentVNode("", true)], 2)])]);
}